import * as React from 'react';

interface Props {
    disptitle: string;
    dispdescription: any;
    light?: boolean;
    shortMargin?: boolean;
    className?: string;
    alignment?: string;
}

const ComponentHeader: React.FC<Props> = ({ dispdescription, disptitle, light, shortMargin, className, alignment }) => {
    const hasTitleOrDescription = !(disptitle === '' && dispdescription === '');
    if (!hasTitleOrDescription) {
        return null;
    }
    const getMarginClass = (hasTitleOrDescription) => {
        if (hasTitleOrDescription && shortMargin) return "mb-4";
        if (hasTitleOrDescription) return "mb-4";
        return '';
    }

    const marginClass = getMarginClass(hasTitleOrDescription);
    const wrapperClass = "mst-component-title " + (className ? className : "") + marginClass + (!!light ? "" : " dark-bg")

    return (
        hasTitleOrDescription &&
        <div className={`${wrapperClass} ${alignment ? "text-" + alignment : ""}`} >

            {
                disptitle &&
                <h2 className="h2" dangerouslySetInnerHTML={{ __html: disptitle }}></h2>
                    
            }
            {
                dispdescription &&
                <div className="mst-component-title-desc" dangerouslySetInnerHTML={{ __html: dispdescription }}></div>                   

            }

        </div>

    );
}

export default ComponentHeader;
